import { maintenanceLogSteps, maintenanceLogs } from '../maintenanceLog'
import { describeTable } from './describeTable'

describeTable(maintenanceLogs, {
  description: `The property's maintenance history book (huoltokirja) as shown in the resident app: one row per maintenance job recorded on a property, either done by Markku (visit_id set) or by the homeowner themselves (visit_id NULL). Names are snapshotted so the entry survives template edits.
Sparse and resident-facing — not every visit produces a log row, and homeowner entries are self-reported. Do not use it for delivered work or revenue: visits / visit_tasks are the source of truth; actual_cost is what the resident typed, not what we invoiced.`,
  columns: {
    visitId:
      'The Markku visit that did the work; NULL for homeowner-recorded jobs.',
    maintenanceTaskId:
      'Template the job was based on; NULL for free-form entries.',
    taskNameSnapshot: 'Task name at the time of logging.',
    completedDate: 'Calendar date the job was done.',
    completedByUserId: 'Technician or resident who did it.',
    actualCost:
      'Cost in euros as entered by the resident; not an invoice amount.',
  },
})

describeTable(maintenanceLogSteps, {
  description:
    'Checklist steps recorded under a maintenance log entry, with the outcome of each. Operational detail.',
  columns: {
    status:
      'completed = done; skipped = not done; issue_found = done but a problem was noted (see notes).',
  },
})
